import { render } from "./auth-expired-session.vue?vue&type=template&id=12b30e96"
import script from "./auth-expired-session.vue?vue&type=script&lang=js"
export * from "./auth-expired-session.vue?vue&type=script&lang=js"

import "./auth-expired-session.vue?vue&type=style&index=0&id=12b30e96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__